module.exports = __webpack_public_path__ + "static/media/facebook.ecea43e3.svg";